<template>
  <a class="guide-button" :class="sizeClass" v-bind="$attrs" @click="$emit('click')">
    <img :src="require(`../assets/img/guide-button/${filename}.png`)" :alt="$slots.default[0].text">
    <slot/>
  </a>
</template>

<script>
export default {
  name: 'GuideButton',
  computed: {
    filename () {
      const classMap = {
        '继续': 'next',
        '返回': 'back',
        '港珠澳大桥建设大事记': 'dsj',
        '人工岛三维透视': 'swts',
        '世界首创钢圆筒快速筑岛法': 'kszd',
        '港珠澳大桥海底沉管隧道建设': 'sdjs',
        '世界最重沉管的建造': 'zzcg',
        '沉管的浮运与安装': 'fcaz',
        '港珠澳大桥主体桥梁工程建设': 'ztql',
        '港珠澳大桥桥墩安装': 'qdaz',
        '钢箱梁桥面吊装': 'qmdz',
        '世界最长钢铁大桥': 'gtdq',
        '海豚塔翻身吊装': 'fsdz',
        '世界最大单体钢桥面铺装': 'qmpz',
        '主体工程全线亮灯': 'qxld',
        '感谢参观': 'gxcg',
      }
      return classMap[this.$slots.default[0].text] || 'no-img'
    },
    sizeClass () {
      const sizeMap = {
        '继续': 'md',
        '返回': 'md',
      }
      return sizeMap[this.$slots.default[0].text] || 'lg'
    },
  },
}
</script>

<style lang="scss" scoped>
.guide-button {
  display: inline-block;
  font-size: 0rem;
  color: transparent;
  text-decoration: none;
  cursor: pointer;
  &.md {
    height: 0.7rem;
  }
  &.lg {
    height: 1.5rem;
  }
  & > img {
    height: 100%;
  }
}
</style>
